import { useCallback } from "react";
import { Control } from "react-hook-form";
import { useIntl } from "react-intl";
import { useAuthContext } from "../../../context/AuthContext";
import useAsyncSelectFormInput from "../../../hooks/useAsyncSelectFormInput";
import organizationService from "../../../services/organization.service";
import SelectFormInput from "../SelectInput/SelectFormInput";

type IEntityFormInput = {
  entity: string;
};

type EntitySelectFormInputProps = {
  control: Control<IEntityFormInput, object>;
  required?: boolean;
  disabled?: boolean;
  isInvalid?: boolean;
  restricted?: "pro" | "non-pro";
  setValueOnChange?: (id: string) => void;
};

const EntitySelectFormInput = ({
  isInvalid,
  disabled,
  control,
  required = false,
  restricted,
  setValueOnChange,
}: EntitySelectFormInputProps) => {
  const {
    state: { user },
  } = useAuthContext();
  const intl = useIntl();

  const entityPlaceholder = intl.messages[
    "MANAGEMENT.ADD_USER.ENTITY_REQUIRED"
  ] as string;

  const loadItems = useCallback(async () => {
    if (!user?.organization?.id) return [];

    const entities = await organizationService.getOrgEntities(
      user.organization.id,
      restricted
    );

    return !entities
      ? []
      : entities?.map((entity) => ({
          key: entity.id,
          value: entity.name,
        }));
  }, [user?.organization?.id, restricted]);

  const { selectItems, selectPlaceholder } = useAsyncSelectFormInput(
    loadItems,
    entityPlaceholder
  );

  const onChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    if (setValueOnChange) {
      const itemId = event.target.value;
      const item = selectItems.find((item) => item.key === itemId);
      item?.value && setValueOnChange(item?.value);
    }
  };

  return (
    <SelectFormInput
      name={"entity"}
      control={control}
      rules={{
        required: required,
      }}
      input={{
        items: selectItems,
        disabled: disabled,
        readOnly: disabled,
        isInvalid: isInvalid,
        placeholder: selectPlaceholder,
        onChange: onChangeHandler,
      }}
    />
  );
};
export default EntitySelectFormInput;
